<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4>添加医学服务</h4></h4>
      <el-button size="small" type="info" @click="backProject">返回</el-button>
    </div>
    <el-card class="box-card">
      <!-- 这里边是一个表单 -->
      <el-form
        ref="form"
        :model="form"
        size="small"
        label-width="80px"
        label-position="top"
      >
        <el-form-item label="服务名称" required>
          <el-col :span="11">
            <el-input
              v-model="form.name"
              placeholder="请输入服务名称"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="服务资料" required>
          <el-col :span="6">
            <el-input
              v-model="form.name"
              placeholder="请输入服务资料"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <!-- 这里是上传文件 -->
          <div class="uploads">
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="3"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button size="small" type="info">选择文件</el-button>
            </el-upload>
            <span class="ticks"
              >请上传TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、PDF 等文件格式</span
            >
          </div>
        </el-form-item>
        <el-form-item required>
          <el-col :span="6">
            <el-input
              v-model="form.name"
              placeholder="请输入资料名称"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="参考文献" required>
          <!-- 这里是上传文件 -->
          <div class="uploads">
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="3"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button size="small" type="info">选择文件</el-button>
            </el-upload>
            <span class="ticks"
              >请上传TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、PDF 等文件格式</span
            >
          </div>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'editorProject',
  data () {
    return {
      form: {
        name: '',
        textarea: ''
      },
      value: '',
      // 搜索专家
      loading: false,
      // 参会专家
      fileList: [{ name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }]
    }
  },
  updated () {
    console.log(this.value3)
  },
  methods: {
    // 点击提交表单
    onSubmit () {
      console.log('submit!')
    },
    backProject () {
      this.$router.push('/')
    },
    // 接口搜索的方法
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options = this.list.filter(item => {
            return item.label.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    // 上传文件开始
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    }
    // 上传文件结束
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .box-card {
    width: 100%;
    flex: 1;
    overflow-y: auto;
  }
  /deep/.el-select {
    display: block;
  }
  //  上传文件样式
  .uploads {
    display: flex;
    .upload-demo {
      display: flex;
      // align-items: center;
      .el-button {
        border-radius: 6px 0 0 6px;
      }
      /deep/ .el-upload-list {
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
        width: 421px;
        height: 32px;
        margin-top: 1px;
        .el-upload-list__item {
          margin: 3px 0;
        }
      }
    }
    .ticks {
      color: #cc0808;
      font-size: 12px;
      margin-top: 10px;
      margin-left: 13px;
    }
  }
}
</style>
